import { createContext } from "react";

import {
  Control,
  DeepMap,
  FieldError,
  NestedValue,
  UseFormRegister,
} from "react-hook-form";
import { Model } from "./queries";

export interface ModelFieldValues {
  displayName: string;
  slug: string;
  workspaceId: string;
  reportId: string;
  productId?: string;
  participantCount: string;
  description: string;
  vendors: NestedValue<Model["vendors"]>;
  launchDate: string;
  embargoEndDate: string;
  drillDownsRole: boolean;
}

export const formContext = createContext<{
  errors?: DeepMap<ModelFieldValues, FieldError>;
  register?: UseFormRegister<ModelFieldValues>;
  control?: Control<ModelFieldValues>;
}>({});
